import { Button, Divider, Input, Switch, Tag } from "antd";
import TableFetchData from "../../components/data-table/TableFetchData";
import { useTranslation } from "react-i18next";
import SelectComponent from "../../components/select/SelectComponent";
import { formatDateTime } from "../../utils/dateFormatUtils";
import DateRangeComponent from "../../components/date/DateRangeComponent";
import AirlyPaySvg from "../../assets/images/AirlyPay";
import WeChatSvg from "../../assets/images/WeChat";
import SearchSvg from "../../assets/images/SearchSvg";
import { useNavigate } from "react-router-dom";
import { ExportExcelListSvg, ExportExcelSvg, RevokeSvg } from "../../assets/images/HeaderSvg";
import MessageConfirmModal from "../../components/messageModal/MessageConfirmModal";
import { useEffect, useRef, useState } from "react";
import { COUPON_URL, COUPON_USED_URL } from "../../api/URLs";
import { getDataRequest, patchDataRequest } from "../../api/serviceMethods";
import dayjs from "dayjs";
import * as XLSX from "xlsx-js-style";
import { IoArrowUndoCircleOutline } from "react-icons/io5";

const TableNoExpired = ({ 
    loading, setLoading, paymentData,memberType,
    keyword, setKeyword,dates, setDates, initLoadPayment,
    dataObject, setDataObject, tableParams, setTableParams
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const messageModalRef = useRef('')
    const [exportData, setExportData] = useState([])
    const [isSearchExport, setIsSearchExport] = useState(false)

    const toggleView = (_id, type) => {
        navigate(`/coupon/details/${_id}?type=${type}`);
    };
    const getValidDate = (record) => {
        if (!record) return "";

        if (record.validityType === "date_range") {
            return record.validTo
                ? dayjs(record.validTo).format("YYYY-MM-DD HH:mm")
                : "";
        }

        if (record.validityType === "days") {
            return record.createdTS && record.validDays
                ? dayjs(record.createdTS)
                    .add(Number(record.validDays), "day")
                    .format("YYYY-MM-DD HH:mm")
                : "";
        }

        return "";
    };

    const handleSwitch = async (item) => {
        try {
          const memberPayload = {
            isActive: !item.isActive
          }
          await patchDataRequest(`${COUPON_URL}/${item?._id}/toggle`, memberPayload)
            .then((res) => {
              if (res || res.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(res && t(res.message), () => { }, "", true);
                initLoadPayment();
              } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.message), () => { }, "", true);
              }
            })
            .catch((err) => {
              messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || t("Server Error!"), () => { }, "", true);
            });
        } catch (error) {
          messageModalRef.current.showWarningConfirmsAutoClose(t(`Server Error!`), () => { }, "", true);
        }
      }

    const handleRevoke = (item) => {
        messageModalRef.current.showWarningConfirm(
            t('Are you sure you want to revoke this coupon?'),
            async () => {
                setLoading(true);
                try {
                    const memberPayload = { status: 'revoke' };
                    const res = await patchDataRequest(`${COUPON_URL}/${item?._id}/status`, memberPayload);
                    if (res && (res.status === 200 || res.success)) {
                        messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.message), () => { }, "", true);
                        initLoadPayment();
                    } else {
                        messageModalRef.current.showWarningConfirmsAutoClose(t(res && res.message), () => { }, "", true);
                    }
                } catch (err) {
                    const errMsg = err && err.response && err.response.data && err.response.data.message || err && err.message || "Server Error!";
                    messageModalRef.current.showWarningConfirmsAutoClose(t(errMsg), () => { }, "", true);
                } finally {
                    setLoading(false);
                }
            },
            "",
            true
        );
    }
    const tableSettings = {
        appendable: false,
        removable: false,
        bordered: true,
        size: "small",
        pagination: {
            showLessItems: true,
            showSizeChanger: false,
            pageSize: 10,
          },
        columns: [
            {
                title: <label className="titleCard14400">{t('Coupon Quantity')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">{record && record.totalQuantity}</label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Coupon Discount')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        {((record?.discountValue ?? 0) * 100).toFixed(0)}{t("per")}
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Discount Type')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        <div className="mb-1 pe-1">
                            <div className="textTag">{record && record?.discountType === "member_discount" ? "会员折扣 " :"会员折扣 "}</div>
                        </div>
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Unused')}</label>,
                render: (_, record) => (
                    <a  onClick={() => toggleView(`${record._id}`, 'unused')} className="text-capitalize">{record && record?.unusedQuantity}</a>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Used')}</label>,
                render: (_, record) => (
                    <a  onClick={() => toggleView(`${record._id}`, 'used')} className="text-capitalize">{record && record?.usedQuantity}</a>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Validity')}</label>,
                dataIndex: 'validDays',
                sorter: true,
                key: 'validDays',
                render: (_, record) => (
                    <label className="text-capitalize">
                        {record && getValidDate(record)}
                    </label>
                ),
            },
            {
                title: <label className="ant-table-column-title titleCard14400">{t('Creation Time')}</label>,
                dataIndex: 'createdTS',
                sorter: true,
                key: 'createdTS',
                render: (_, record) => (
                    <>
                        {record.createdTS ? formatDateTime(record.createdTS) : ""}
                    </>
                )
            },
            {
                title: <label className="titleCard14400">{t('Remark')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        {t(record && record?.remarks)}
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Operator')}</label>,
                render: (_, record) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <Switch onChange={() => handleSwitch(record)} checked={record.isActive} />
                        <div style={{ cursor: 'pointer' }} onClick={() => exportOrderByOne(record)}>
                            <ExportExcelListSvg height={25} width={25}/>
                        </div>
                        {
                            record?.unusedQuantity > 0 && memberType === "unexpired" && 
                            <div className="flex items-center justify-center" style={{ cursor: 'pointer' }} onClick={() => handleRevoke(record)}>
                                <RevokeSvg height={25} width={25} />
                            </div>
                        }
                    </div>
                ),
            },
        ],
    };

    const prepareExportData = (data, t) => {
        return data.map(record => ({
            [t("Coupon Quantity")]: record && record?.totalQuantity,
            [t("Coupon Discount")]: `${((record?.discountValue ?? 0) * 100).toFixed(0)}${t("per")}`,
            [t("Discount Type")]: record && record?.discountType === "member_discount" ? "会员折扣 " :"会员折扣 ",
            [t("Unused")]: record && record?.unusedQuantity,
            [t("Used")]: record && record?.usedQuantity,
            [t("Validity")]: record && getValidDate(record),
            [t("Creation Time")]: record.createdTS ? formatDateTime(record.createdTS) : "",
            [t("Remark")]: record && record?.remarks,
        }));
    };

    const applyStylesToSheet = (worksheet, headerRowIndices, boldCellKeys = []) => {
        if (!worksheet['!ref']) return;
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        
        const borderStyle = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
        };

        const rowHeights = [];

        for (let R = range.s.r; R <= range.e.r; ++R) {
            rowHeights[R] = { hpt: 22 }; // Set row height to 22 points
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (!worksheet[cellAddress]) continue;
                
                const isHeaderRow = headerRowIndices.includes(R);
                const isBoldCell = boldCellKeys.includes(cellAddress);
                
                worksheet[cellAddress].s = {
                    ...worksheet[cellAddress].s,
                    border: borderStyle,
                    font: (isHeaderRow || isBoldCell) ? { bold: true } : {},
                    alignment: { vertical: "center", horizontal: "left" }
                };
            }
        }
        
        worksheet['!rows'] = rowHeights;
    };

    const autoSizeColumns = (worksheet) => {
        if (!worksheet['!ref']) return;
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const colWidths = [];

        for (let C = range.s.c; C <= range.e.c; ++C) {
            let maxWidth = 10; // Minimum width
            for (let R = range.s.r; R <= range.e.r; ++R) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = worksheet[cellAddress];
                if (cell && cell.v !== undefined && cell.v !== null) {
                    const cellValue = String(cell.v);
                    let length = 0;
                    for (let i = 0; i < cellValue.length; i++) {
                        // Double width for Chinese characters, single for others
                        if (cellValue.charCodeAt(i) > 255) {
                            length += 2.2;
                        } else {
                            length += 1.2;
                        }
                    }
                    if (length > maxWidth) {
                        maxWidth = length;
                    }
                }
            }
            colWidths[C] = { wch: maxWidth + 2 }; // Add padding
        }
        worksheet['!cols'] = colWidths;
    };

    const exportToExcel = (data, t, fileName = `${memberType ==="unexpired" ? t("No Expired") :t("Expired")}.xlsx`) => {
        const exportData = prepareExportData(data, t);
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        applyStylesToSheet(worksheet, [0]);
        autoSizeColumns(worksheet);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, fileName);
    };

    const exportOrder = async () => {
        setLoading(true);
        await getDataRequest(`${COUPON_URL}`, {
            keyword: keyword.trim(),
            startDate: dates[0] || "",
            endDate: dates[1] || "",
            status:memberType,
            paymentType: dataObject.type,
            paymentMethod: dataObject.method,
            // orderType: memberType,
            pageNo: tableParams.pagination.current,
            sortKeys: { [tableParams.sortField]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
            pageSize: tableParams.pagination.pageSize
        }).then(res => {
            setLoading(false);
            if (res.status === 200) {
                setExportData(res?.data);
                exportToExcel(res.data, t);
                setTableParams({
                    ...tableParams
                });
            }
        }).catch((err) => {
            setLoading(false);
            console.log("Error", err);
        });
    };

    const exportSingleOrderToExcel = (record, data, t, fileName = `${memberType ==="unexpired" ? t("No Expired") :t("Expired")}.xlsx`) => {
        const aoa = [
            [t("Coupon Quantity"), `${record?.totalQuantity || 0}`, t("Discount Type"), record?.discountType === "member_discount" ? "会员折扣 " :"会员折扣 "],
            [t("Coupon Discount"), `${((record?.discountValue ?? 0) * 100).toFixed(0)}${t("per")}`, t("Validity"), record && getValidDate(record)],
            [t("Unused"), `${record?.unusedQuantity || 0}`, t("Used"), `${record?.usedQuantity || 0}`],
            [],
            [t("Coupon Code"), t("User ID"), t("Payment Amount"), t("Order Number"), t("Used Time"), t("Payment Portal"), t("Status")]
        ];

        if (data && data.length > 0) {
            data.forEach(item => {
                aoa.push([
                    item?.couponCode || "",
                    item?.memberId || "",
                    item?.paidAmount ? `¥${item.paidAmount}` : "",
                    item?.orderId || "",
                    item?.usedTS ? formatDateTime(item.usedTS) : "",
                    item?.paymentGateway ? (item.paymentGateway.toLowerCase() === 'alipay' ? 'Alipay' : (item.paymentGateway.toLowerCase().includes('wechat') ? 'Wechat Pay' : item.paymentGateway)) : "",
                    (item?.status || "").charAt(0).toUpperCase() +
                    (item?.status || "").slice(1).toLowerCase()
                ]);
            });
        }

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        
        applyStylesToSheet(worksheet, [4], ['A1', 'C1', 'A2', 'C2', 'A3', 'C3']);
        autoSizeColumns(worksheet);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, fileName);
    };

    const exportOrderByOne = async (recoard) => {
        setLoading(true);
        await getDataRequest(`${COUPON_USED_URL}/${recoard?._id}`, {
            keyword: keyword.trim(),
            startDate: dates[0] || "",
            endDate: dates[1] || "",
            status: "ALL",
            // paymentType: dataObject.type,
            // paymentMethod: dataObject.method,
            // orderType: memberType,
            // pageNo: tableParams.pagination.current,
            // sortKeys: { [tableParams.sortField]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
            // pageSize: tableParams.pagination.pageSize
        }).then(res => {
            setLoading(false);
            if (res && res.status === 200) {
                setExportData(res?.data);
                exportSingleOrderToExcel(recoard, res.data, t);
                setTableParams({
                    ...tableParams
                });
            }
        }).catch((err) => {
            setLoading(false);
            console.log("Error", err);
        });
    };

    return (
        <>
            <div className="w-100" style={{ padding: "0px 25px" }}>
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                        <Input
                            placeholder={t("Search")}
                            prefix={<SearchSvg style={{ color: '#8c8c8c' }} />}
                            size="large"
                            className='me-3 col-5'
                            disabled={loading}
                            loading={loading}
                            allowClear
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                        <DateRangeComponent
                            className="col-4 me-4"
                            placeholder={t("Please select a time or time period")}
                            disabled={loading}
                            value={dates ? dates : [null, null]}
                            setValue={setDates}
                        />
                    </div>
                    <div className="d-flex align-items-center">
                        <Button
                            size="large"
                            onClick={() => {
                                setTableParams({
                                    ...tableParams,
                                    pagination: {
                                        ...tableParams.pagination,
                                        current: 1,
                                    },
                                });
                                initLoadPayment();
                            }}
                        >
                            {t('Query')}
                        </Button>
                        <Divider type="vertical" style={{ height: '40px', borderColor: '#d9d9d9' }} />
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setTimeout(() => {
                                    exportOrder();
                                }, 100);
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            <ExportExcelSvg />
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100" style={{ padding: "0px 25px" }}>
                <TableFetchData
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    data={paymentData}
                    columns={tableSettings.columns}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>
            <MessageConfirmModal textCentered ref={messageModalRef} />
        </>
    );
};

export default TableNoExpired;
